module.exports = __webpack_public_path__ + "static/media/card-2.0d2310eb.svg";